export const contractConstants = {
   ADD_CONTRACT_REQUEST:         'ADD_CONTRACT_REQUEST',
   ADD_CONTRACT_SUCCESS:         'ADD_CONTRACT_SUCCESS',
   ADD_CONTRACT_FAILURE:         'ADD_CONTRACT_FAILURE',
   GET_CONTRACT_REQUEST:         'GET_CONTRACT_REQUEST',
   GET_CONTRACT_SUCCESS:         'GET_CONTRACT_SUCCESS',
   GET_CONTRACT_FAILURE:         'GET_CONTRACT_FAILURE',
   GET_CONTRACT_NOT_EXECUTED_REQUEST:         'GET_CONTRACT_NOT_EXECUTED_REQUEST',
   GET_CONTRACT_NOT_EXECUTED_SUCCESS:         'GET_CONTRACT_NOT_EXECUTED_SUCCESS',
   GET_CONTRACT_NOT_EXECUTED_FAILURE:         'GET_CONTRACT_NOT_EXECUTED_FAILURE',
   DELETE_CONTRACT_REQUEST:      'DELETE_CONTRACT_REQUEST',
   DELETE_CONTRACT_SUCCESS:      'DELETE_CONTRACT_SUCCESS',
   DELETE_CONTRACT_FAILURE:      'DELETE_CONTRACT_FAILURE',
   GET_CONTRACTDETAIL_REQUEST:   'GET_CONTRACTDETAIL_REQUEST',
   GET_CONTRACTDETAIL_SUCCESS:   'GET_CONTRACTDETAIL_SUCCESS',
   GET_CONTRACTDETAIL_FAILURE:   'GET_CONTRACTDETAIL_FAILURE',
   UPDATE_CONTRACT_REQUEST:      'UPDATE_CONTRACT_REQUEST',
   UPDATE_CONTRACT_SUCCESS:      'UPDATE_CONTRACT_SUCCESS',
   UPDATE_CONTRACT_FAILURE:      'UPDATE_CONTRACT_FAILURE',
   CLONE_CONTRACT_REQUEST:      'CLONE_CONTRACT_REQUEST',
   CLONE_CONTRACT_SUCCESS:      'CLONE_CONTRACT_SUCCESS',
   CLONE_CONTRACT_FAILURE:      'CLONE_CONTRACT_FAILURE',
   CLONE_CONTRACT_NON_EXECUTED_REQUEST:      'CLONE_CONTRACT_NON_EXECUTED_REQUEST',
   CLONE_CONTRACT_NON_EXECUTED_SUCCESS:      'CLONE_CONTRACT_NON_EXECUTED_SUCCESS',
   CLONE_CONTRACT_NON_EXECUTED_FAILURE:      'CLONE_CONTRACT_NON_EXECUTED_FAILURE',
   POST_CONTRACTEXECUTE_REQUEST: 'POST_CONTRACTEXECUTE_REQUEST',
   POST_CONTRACTEXECUTE_SUCCESS: 'POST_CONTRACTEXECUTE_SUCCESS',
   POST_CONTRACTEXECUTE_FAILURE: 'POST_CONTRACTEXECUTE_FAILURE',
   POST_CONTRACTPHYSICAL_REQUEST: 'POST_CONTRACTPHYSICAL_REQUEST',
   POST_CONTRACTPHYSICAL_SUCCESS: 'POST_CONTRACTPHYSICAL_SUCCESS',
   POST_CONTRACTPHYSICAL_FAILURE: 'POST_CONTRACTPHYSICAL_FAILURE',
   SEND_MAIL_REQUEST:            'SEND_MAIL_REQUEST',
   SEND_MAIL_SUCCESS:            'SEND_MAIL_SUCCESS',
   SEND_MAILFAILURE:             'SEND_MAILFAILURE',
   POST_CONTRACTTYPE_REQUEST:            'POST_CONTRACTTYPE_REQUEST',
   POST_CONTRACTTYPE_SUCCESS:            'POST_CONTRACTTYPE_SUCCESS',
   POST_CONTRACTTYPE_FAILURE:             'POST_CONTRACTTYPE_FAILURE',
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/contractConstants.js